<template>
  <el-collapse v-model="collapseModel">
    <elemento-header
      :title="title"
      :name="name"
    >
      <!-- <input-suaje
        v-model="localModel"
        v-bind="componentsProps.InputSuaje"
        :validate="validarOrdenProduccionCampos"
      /> -->

      <!-- <el-row :gutter="24">
        <input-familia-material
          v-model="localModel.MateriaPrimaFamilia"
          :disabled="!!localModel.Suaje?.SuajeMateriaPrimaFamilia?.length && localModel.Suaje.SuajeMateriaPrimaFamilia[0]?.CodigoMateriaPrimaFamilia > 0"
          :validar="!validarOrdenProduccionCampos.FamiliaMaterial"
        />
      </el-row> -->

      <!-- <el-row :gutter="24" style="margin-top: 1rem; margin-bottom: 1rem">
        <custom-input-number
          :label="'Densidad resultante'"
          :spanColumn="4"
          :settings="{
            placeholder: 'Densidad resultante',
            min: 0,
            step: 0.01,
            precision: 2,
            controls: false
          }"
          v-model="densidadResultante"
        />
        <custom-data
          :label="'Cantidad de Capas'"
          :spanColumn="8"
          :data="cantidadCapas"
        />
      </el-row> -->

      <input-procesos
        v-model="localModel.Secciones"
        :elemento-tipo="localModel.ElementoTipo"
      />
      <el-divider></el-divider>
    </elemento-header>
  </el-collapse>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import {
  computed,
  ref,
  watch,
  onMounted,
  provide,
} from 'vue';
import { useElemento } from '@/shared/composables/useElemento.js';
import { useWorkOrderStore } from '@/views/work_orders/stores/work_order_store.js';

import CustomData from '@/shared/components/custom_data.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import InputFamiliaMaterial from '@/shared/components/input_familia_material.vue';
import InputProcesos from '@/shared/components/procesos/input_procesos.vue';
import InputSuaje from '@/shared/components/suaje/input_suaje.vue';

import { useComponentsProps } from '@/shared/composables/use_components_props.js';
import { Modules } from '@/enum/modules';
import { ElementoBase } from '@/enum/elemento_base';
import { Seccion } from '@/enum/seccion';

const emit = defineEmits(['update:modelValue']);

const workOrderStore = useWorkOrderStore();
const { validarOrdenProduccionCampos } = storeToRefs(workOrderStore);
const { componentsProps } = useComponentsProps(ElementoBase.EXTRUSION, Modules.ORDEN_PRODUCCION);

const props = defineProps({
  modelValue: { type: Object, required: true },
  title: { type: String, required: true },
  name: { type: String, required: true },
});

const { localModel, collapseModel, updateModelo } = useElemento(props, emit);

provide('currentElementoBase', ElementoBase.EXTRUSION);

// Proveer valores de imposición para componentes de proceso
const imposicionProvidedValue = computed(() => ({
  EtiquetasEje: localModel.value.EtiquetasEje || 0,
  EtiquetasDesarrollo: localModel.value.EtiquetasDesarrollo || 0,
}));

provide('imposicion', imposicionProvidedValue);

const densidadManualmenteModificada = ref(false);

const cantidadCapas = computed(() => {
  const secciones = Array.isArray(localModel.value?.Secciones) ? localModel.value.Secciones : [];

  const seccionesEstructura = secciones.filter((s) => s.Codigo === Seccion.MATERIAS_PRIMAS);

  const esProcesoMultiMaterial = (procesoWrapper) => {
    if (!procesoWrapper) return false;

    const proc = procesoWrapper.Proceso || {};
    if (proc.MultiMaterial === true) return true;

    const catsWrapper = Array.isArray(procesoWrapper.CategoriasMaterial)
      ? procesoWrapper.CategoriasMaterial
      : [];

    if (catsWrapper.some((c) => c?.MultiMaterial === true)) return true;

    const catsProc = Array.isArray(proc.CategoriasMaterial) ? proc.CategoriasMaterial : [];

    if (catsProc.some((c) => c?.MultiMaterial === true)) return true;

    const rels = Array.isArray(proc.ProcesoElementoTipoCategoriaMaterial)
      ? proc.ProcesoElementoTipoCategoriaMaterial
      : [];

    if (rels.some((rel) => rel && rel.MultiMaterial)) return true;

    return false;
  };

  return seccionesEstructura.reduce((total, seccion) => {
    const procesos = Array.isArray(seccion.ElementoProceso) ? seccion.ElementoProceso : [];

    const multi = procesos.filter((p) => esProcesoMultiMaterial(p)).length;
    return total + multi;
  }, 0);
});

const densidadResultanteCalculada = computed(() => {
  const secciones = Array.isArray(localModel.value?.Secciones) ? localModel.value.Secciones : [];

  const procesosSeccion = secciones
    .filter((s) => s.Codigo === Seccion.MATERIAS_PRIMAS)
    .flatMap((seccion) => (Array.isArray(seccion.ElementoProceso) ? seccion.ElementoProceso : []));

  if (procesosSeccion.length === 0) return 0;

  const total = procesosSeccion.reduce((acumGlobal, procesoWrapper) => {
    const proc = procesoWrapper || {};

    const porcProceso = Number(proc.Porcentaje ?? 0);
    if (!Number.isFinite(porcProceso) || porcProceso === 0) {
      return acumGlobal;
    }

    const categorias =
      Array.isArray(proc.CategoriasMaterial) && proc.CategoriasMaterial.length > 0
        ? proc.CategoriasMaterial
        : Array.isArray(proc.Proceso?.CategoriasMaterial)
          ? proc.Proceso.CategoriasMaterial
          : [];

    let aporteProceso = 0;

    categorias.forEach((cat) => {
      const materiales = Array.isArray(cat?.ElementoMateriales) ? cat.ElementoMateriales : [];

      materiales.forEach((mat) => {
        const porcMat = Number(mat?.Porcentaje ?? 0);
        if (!Number.isFinite(porcMat) || porcMat === 0) return;

        const dens = mat?.Densidad ?? mat?.Material?.Densidad ?? null;

        if (!dens || !Number.isFinite(Number(dens))) return;

        const aporteMaterial = (Number(dens) * porcMat) / 100;
        aporteProceso += aporteMaterial;
      });
    });

    const aporteProcesoTotal = (aporteProceso * porcProceso) / 100;
    return acumGlobal + aporteProcesoTotal;
  }, 0);

  return Number(total.toFixed(4));
});

const densidadResultante = computed({
  get() {
    if (densidadManualmenteModificada.value) {
      return localModel.value.DensidadResultante || 0;
    }
    return densidadResultanteCalculada.value;
  },
  set(value) {
    if (value === null || value === undefined || value === '') {
      densidadManualmenteModificada.value = false;
      const calculada = densidadResultanteCalculada.value;

      localModel.value.DensidadResultante =
        calculada !== null && calculada !== undefined ? calculada : null;

      return;
    }
    densidadManualmenteModificada.value = true;
    localModel.value.DensidadResultante = value;
  },
});

onMounted(() => {
  const valorInicial = localModel.value?.DensidadResultante;
  if (valorInicial !== null && valorInicial !== undefined) {
    densidadManualmenteModificada.value = true;
  }
});

watch(
  () => densidadResultanteCalculada.value,
  (nuevaCalculada) => {
    if (!densidadManualmenteModificada.value) {
      localModel.value.DensidadResultante =
        nuevaCalculada !== null && nuevaCalculada !== undefined ? nuevaCalculada : null;
    }
  },
);
</script>
